import { render, staticRenderFns } from "./ChatDateTime.vue?vue&type=template&id=5c3944f3&scoped=true"
import script from "./ChatDateTime.vue?vue&type=script&lang=js"
export * from "./ChatDateTime.vue?vue&type=script&lang=js"
import style0 from "./ChatDateTime.vue?vue&type=style&index=0&id=5c3944f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3944f3",
  null
  
)

export default component.exports